import { render, staticRenderFns } from "./chargesExternesAndCAVersionDetailed.vue?vue&type=template&id=7b960d87&"
import script from "./chargesExternesAndCAVersionDetailed.vue?vue&type=script&lang=js&"
export * from "./chargesExternesAndCAVersionDetailed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports